const ssoClientIds = {
  dev: '0oawn4mus5L1e9MWF0h7',
  rc: '0oawn55dbvJFuHHm50h7',
  production: '0oa7ets4ozorYwhgy357',
};

const env = (window.NextivaEnv || 'dev').toLowerCase();

export const ssoClientId = ssoClientIds[env] || ssoClientIds.dev;
